import Router from '@/router'

export default function InstallCache(NetteAjax) {
  // cache ajax results
  return NetteAjax.ext('cache', {
    before (settings) {
      if (settings.nette && settings.nette.form) return

      // we will use cached data when:
      // we known cache ident - templateId (not implemented) - OR - Vue route name

      // if isset route
      if (settings.route) {
        const newRoute = Router.resolve(settings.route)
        if (newRoute.matched[0]?.name) {
          if (newRoute.matched[0].name in this.cachedResponses) {
            settings.cachedData = {...this.cachedResponses[newRoute.matched[0].name]}
          } else {
            settings.cacheKey = newRoute.matched[0].name
          }
        }
      }
    },
    success (payload, response, settings) {
      if (settings.nette && settings.nette.form) return

      if (!settings.cacheKey) return

      this.cachedResponses[settings.cacheKey] = payload
    }
  }, {
    cachedResponses: {} // route.name => response
  })
}
